import type { TFunction } from 'i18next'

// YesOrNo answers are always saved as the untranslated strings 'Yes' / 'No', so translate them for display only
export function translateYesOrNoAnswer(value: any, t: TFunction): any {
  if (value === 'Yes') return t('Buttons.yes')
  if (value === 'No') return t('Buttons.no')
  return value
}
